import React from 'react';
import { Col, Row } from 'react-bootstrap';

const DownloadButton = ({ data }: any) => {
  return (
    <div className="container">
      <Row md={2} xs={1}>
        {data.Buttons.map((item: any, i: number) => {
          return (
            <Col key={i}>
              <div className="DownloadButton-flex">
                <h4 className="DownloadButton-flex-h4">{item.label}</h4>
                <div>
                  {' '}
                  <a href={item.buttonLink} className="DownloadButton-watch-download">
                    {item.buttonLabel}
                  </a>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default DownloadButton;
